import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import TaskStatusIcon from "../../../../../../assets/icons/Icon-Status-Blue-20px.svg";
import BaseStatusRow from "./BaseStatusRow";
import CustomStatusRow from "./CustomStatusRow";
import HiddenBaseStatusRow from "./HiddenBaseStatusRow";
import SectionSubheader from "../subcomponents/SectionSubheader";

const TaskStatusSection = ({
  workflowBaseStatuses,
  workflowStatuses,
  setSelectedWorkflowStatus,
  setIsModelOpen,
  hideBaseStatus,
  setFieldName,
  handleStatusSwap,
  removeField,
  removeInitialStatus,
  addNewWorkflowStatus,
}) => {
  const workflowBaseStatusList = (workflowBaseStatuses || []).filter((x) => !x.IsHidden && x.IsBase);
  const workflowBaseStatusListCount = workflowBaseStatusList.length;
  const workflowCustomStatusList = (workflowStatuses || []).filter((x) => !x.IsHidden && !x.IsBase);
  const workflowCustomStatusListCount = workflowCustomStatusList.length;

  return (
    <div className="workflow-section-panel">
      <div className="workflow-section-description">
        <img src={TaskStatusIcon} alt="Task Statuses" />
        Task Statuses
      </div>

      <div className="workflow-status-section-body">
        {/* Base Statuses header */}
        <SectionSubheader title="TRIYO Base Statuses" count={workflowBaseStatusListCount} />
        { workflowBaseStatusList.map((field, fieldIdx) => (
            <BaseStatusRow
              key={field?.Id}
              field={field}
              index={fieldIdx}
              onHide={(id, hidden) => hideBaseStatus(id, hidden)}
              onOpen={(f) => {
                setSelectedWorkflowStatus({ ...f });
                // keep parity with current behavior (modal may open internally)
                // if your modal expects explicit open, uncomment next line:
                // setIsModelOpen(true);
              }}
            />
          ))
        }

        {/* Custom Statuses header */}
        <SectionSubheader title="Custom Statuses" count={workflowCustomStatusListCount} />
        { workflowCustomStatusList.map((field, fieldIdx) => (
          <CustomStatusRow
            key={field?.Id}
            field={field}
            index={fieldIdx}
            baseVisibleCount={(workflowBaseStatuses || []).filter((x) => !x.IsHidden)?.length || 0}
            isFirst={fieldIdx === 0}
            isLast={fieldIdx === workflowCustomStatusList.length - 1}
            onNameChange={(id, name) => setFieldName(id, name)}
            onOpen={(f) => {
              setSelectedWorkflowStatus({ ...f });
              // setIsModelOpen(true);
            }}
            onMoveUp={() => handleStatusSwap(fieldIdx - 1, fieldIdx)}
            onMoveDown={() => handleStatusSwap(fieldIdx, fieldIdx + 1)}
            onDelete={() => {
              removeField(fieldIdx);
              removeInitialStatus(field.Name);
            }}
          />
        ))}

        <div className="add-btn-workflow-container mb-3">
          <Button className="add-field-btn-workflow" variant="outline-primary" onClick={addNewWorkflowStatus}>
            <span className="add-field-btn-text">Add New Task Status</span>
            <div className="add-field-icon" />
          </Button>
        </div>

        { (workflowBaseStatuses || [])
          .filter((x) => x.IsHidden)
          .map((field, fieldIdx) => (
            <HiddenBaseStatusRow key={field?.Id} field={field} index={fieldIdx} onUnhide={(id, hidden) => hideBaseStatus(id, hidden)} />
          ))
        }
      </div>
    </div>
  );
};

TaskStatusSection.propTypes = {
  workflowBaseStatuses: PropTypes.array.isRequired,
  workflowStatuses: PropTypes.array.isRequired,
  setSelectedWorkflowStatus: PropTypes.func.isRequired,
  setIsModelOpen: PropTypes.func.isRequired,
  hideBaseStatus: PropTypes.func.isRequired,
  setFieldName: PropTypes.func.isRequired,
  handleStatusSwap: PropTypes.func.isRequired,
  removeField: PropTypes.func.isRequired,
  removeInitialStatus: PropTypes.func.isRequired,
  addNewWorkflowStatus: PropTypes.func.isRequired,
};

export default TaskStatusSection;
